// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useQuery } from '@tanstack/react-query';

import { getPasswordExpirationInfo } from '../../api/portalServices';
import type { PasswordExpirationInfoGetResponse } from '../../api/types';

const PASSWORD_EXPIRATION_INFO_QUERY_KEY = ['password-expiration-info'];

export const usePasswordExpirationInfo = () => {
  return useQuery<PasswordExpirationInfoGetResponse>({
    queryKey: PASSWORD_EXPIRATION_INFO_QUERY_KEY,
    queryFn: getPasswordExpirationInfo,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export default { usePasswordExpirationInfo };
